/**
 * Sections du hub Paramètres — source unique (id + clé i18n).
 * Le sous-rail (Sidebar) et le contenu (SettingsHubPage) en dérivent.
 * Consolidation des paramètres de config par module dans un hub unique.
 */
export const SETTINGS_SECTIONS = [
  { id: 'general', labelKey: 'settings:tabs.general' },
  // TVA et lignes de crédit partis dans Finance › Paramètres le 2026-08-10 :
  // un réglage financier vit dans le module Finance, pas dans un hub transverse.
  // Utilisateur — lecture seule : mon compte, mon rôle, la grille des rôles.
  { id: 'access',  labelKey: 'settings:tabs.access' },
  /* PLANIFICATION, juste après Utilisateur (demande d'Olivier, 2026-09-29) :
     l'horizon et le niveau de planification, puis les VERSIONS DE PLAN
     (décision 2026-09-27), qui se créent, se verrouillent et se désignent ICI,
     par l'administrateur ou le financier ; les modules ne font que choisir
     celle qu'ils lisent, dans la bande de contexte. */
  { id: 'planning',  labelKey: 'settings:tabs.planning' },
  /* RÉFÉRENTIELS DU CLIENT (décision Olivier, 2026-09-27) : la structure des
     rapports, les réglages financiers et les taux de charges sociales sont lus
     par PLUSIEURS modules. Ils appartenaient à Finance et à People, si bien
     qu'un client qui n'a pas Finance n'avait pas de plan comptable et ne
     pouvait rien imputer. Ils vivent donc ici, une fois pour tous.
     ⚠️ La LPP ne suit PAS : elle est nominative et confidentielle, elle reste
     dans People. */
  { id: 'finance',   labelKey: 'settings:tabs.finance' },
  { id: 'structure', labelKey: 'settings:tabs.structure' },
  // `lock` : section réservée, marquée d'un cadenas dans le menu (2026-10-11).
  { id: 'social',    labelKey: 'settings:tabs.social', lock: true },
  // « People » (13e/14e salaire) rendu au module People le 2026-08-09 :
  // People › Données › Autres paramètres. Un réglage métier vit dans son module.
  /* DONNÉES (2026-10-11) : l'export Excel et la sauvegarde JSON du client,
     pour qui lit People et Finance (`canExportData`). L'import, la
     restauration, le renommage et la suppression restent à l'Administration. */
  { id: 'data',      labelKey: 'settings:tabs.data', lock: true },
];

export const SETTINGS_SECTION_IDS = SETTINGS_SECTIONS.map((s) => s.id);
